import React from 'react';
import LoginComponent from '../../components/Login/LoginComponent';
import style from "./LoginPage.module.css"

const LoginPage = () => {
  return (
    <div className={style.loginPage}>
      <LoginComponent />
    </div>
  );
};

export default LoginPage;
